import script from "./StepTwo.vue?vue&type=script&setup=true&lang=js"
export * from "./StepTwo.vue?vue&type=script&setup=true&lang=js"

import "./StepTwo.vue?vue&type=style&index=0&id=5fc4e754&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fc4e754"]])

export default __exports__